import { useRef } from "react";
import iconv from "iconv-lite";
import { Button } from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { parseUsersCsvToDict } from "./CsvParser";


const encoding = "utf-8";


function UpdateUsers({ onPreviewUsers }) {
  const fileInputRef = useRef(null);

  const loadUsersCsvFile = file => {
    const reader = new FileReader();

    reader.onload = (e) => {
      try {
        const fileContentArray = new Uint8Array(e.target.result);
        const fileContent = iconv.decode(fileContentArray, encoding);
        const content = parseUsersCsvToDict(fileContent);
        onPreviewUsers(content.users, file.name, content.isQuestionnaireMissing);
      } catch (err) {
        console.error(`Error parsing file: (${file.name}):`, err);
        alert(`Error parsing the selected file (${file.name}): ${err.name}: ${err.message}`);
      }
    };

    reader.onerror = e => {
      const err = e.target.error;
      console.error(`File reading error:`, err);
      alert(`Failed to read the selected file (${file.name}): ${err.name}: ${err.message}`);
      if (fileInputRef.current) fileInputRef.current.value = null;
    };

    try {
      reader.readAsArrayBuffer(file);
    } catch (err) {
      console.error("Failed to start reading file:", err);
      alert(`Failed to read the selected file (${file.name}): ${err.name}: ${err.message}`);
      if (fileInputRef.current) fileInputRef.current.value = null;
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) loadUsersCsvFile(file);
  };

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
      fileInputRef.current.click();
    }
  };

  return (
    <>
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        accept=".csv"
        style={{ display: "none" }}
      />
      <Button
        variant="outlined"
        color="primary"
        startIcon={<UploadFileIcon />}
        onClick={handleButtonClick}
        sx={{
          minWidth: 200,
          m: 0 // Remove any default margins
        }}
      >
        Select Users CSV
      </Button>
    </>
  );
}

export default UpdateUsers;
